//USING THIS TO HAVE REM LIKE MANAGMENT OF HEADER-SIZES WHICH OFTEN HAVE A DIFFERENT FONT
const remCalc = function(size) {
  if (isNaN(size)) {
    size = parseInt(size);
  }
  return size / typography.size.replace('px', '') + 'rem';
};

//COLORS VARIABLES
const colors = {
  white: '#FFF',
  black: '#111',
  red: '#E82A2A',
  green: '#69a24c',
  yellow: '#FFF111',
  font: '#222',
  primary: '#EE1D23',
  primaryLight: '#EE1D2359',
  primaryDark: '#a01b1f',
  secondary: '#383A42',
  discount: '#b44e3c',
  link: '#ce3c8a',
  border: '#DDD',
  borderLight: '#F1F1F1',
  borderDark: '#333',
  borderInput: '#AAA',
  lightgrey: '#f6f6f6',
  vanillaWhite: '#fbf8f4',
  grey: '#565558',
  error: '#ff3131',
  success: '#69a24c',
  greys: [
    '#F9F9F9',
    '#F1F1F1',
    '#D5D5D5',
    '#C4C4C4',
    '#9A9A9A',
    '#777777',
    '#3B3B3B'
  ]
};
colors.buy = '#EE1D23';
colors.backgroundLight = colors.greys[0];
colors.backgroundDark = colors.yellow;
colors.inStock = '#339600';
colors.outOfStock = colors.red;

//FONTS
const font = {
  primary: 'DinNext',
  secondary: 'DinNextCond'
};

const weights = {
  ultra: 100,
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700
};

//TYPOGRAPHY
let typography = {
  fontFamily: font.primary,
  fontWeight: weights.light,
  size: '14px',
  letterSpacing: '1.2px',
  paragraph: {
    fontSize: '1rem',
    lineHeight: '1.7em',
    marginBottom: '1rem'
  },
  header: {
    fontFamily: font.primary,
    textTransform: 'uppercase',
    fontWeight: weights.light,
    letterSpacing: '1px',
    secondFont: {
      fontFamily: font.secondary,
      fontWeight: weights.light
    },
    secondColor: {
      color: colors.primary
    }
  }
};

//HEADER FONTSIZES h1-h5 (sm & md & lg & xl)
typography.header.fontSize = [
  '__',
  [remCalc(28), remCalc(31), remCalc(41), remCalc(52)],
  [remCalc(24), remCalc(24), remCalc(28), remCalc(31)],
  [remCalc(18), remCalc(20), remCalc(21), remCalc(21)],
  [remCalc(15), remCalc(16), remCalc(17), remCalc(17)],
  [remCalc(14), remCalc(14), remCalc(14), remCalc(14)]
];

const config = {
  storeName: process.env.REACT_APP_SHOP_NAME || 'Ledlenser',
  routes: {
    favourites: {
      path: process.env.REACT_APP_FAV_PATH || '/bookmarks'
    },
    blog: {
      path: process.env.REACT_APP_BLOG_PATH || '/stories',
      id: process.env.REACT_APP_BLOG_ID || 156,
      mainLevel: 1,
      menu: true
    },
    brand: {
      id: process.env.REACT_APP_BRAND_ID || 0
    },
    myPages: {
      showNewsletter: true,
      showMemberCode: false,
      showAccessCode: false
    }
  },
  lipScore: {
    NO: '652a17eaf750bed0ce283651',
    SE: '97b63debb425cc7ef4292843'
  },
  settings: {
    buyButtons: true,
    channelSelector: false,
    siteContentId: process.env.REACT_APP_SITECONTENT_ID || 51
  }
};

const general = {
  maxWidth: '1600px',
  maxWidthText: '1000px',
  pagePadding: {
    lg: '1rem',
    md: '1rem',
    sm: '1rem'
  },
  hallmarkBorder: '2px solid ' + colors.borderDark,
  radius: '3px'
};

//BUTTON
const button = {
  background: colors.font,
  backgroundSecondary: '#777',
  color: colors.white,
  colorSecondary: colors.white,
  fontFamily: font.primary,
  fontWeight: weights.normal,
  fontSize: typography.header.fontSize[5],
  ListFontSize: typography.header.fontSize[5],
  textTransform: 'uppercase',
  letterSpacing: '1.5px'
};

//AREAS

//TOPBAR
const topBar = {
  height: {
    lg: 40,
    md: 40,
    sm: 40,
    scroll: 0
  },
  color: colors.white,
  background: colors.black,
  fontSize: '0.9rem',
  fontWeight: weights.light,
  usp: {
    fontSize: remCalc(15),
    fontWeight: weights.light
  }
};

//DESKTOP HEADER
const desktopHeader = {
  height: {
    lg: 70,
    md: 70,
    scroll: 70
  },
  search: {
    height: {
      lg: 30,
      md: 30
    }
  },
  logo: {
    width: {
      lg: '200px',
      xl: '200px',
      scroll: '200px'
    }
  },
  background: colors.white,
  color: colors.font,
  nav: {
    fontSize: [remCalc(15), remCalc(17)],
    fontWeight: weights.medium,
    padding: '1rem',
    barHoverColor: colors.buy,
    subMenu: {
      lv2: {
        fontSize: '1.1rem'
      },
      lv3: {
        fontSize: '0.9rem'
      }
    },
    height: {
      lg: 70,
      md: 70,
      scroll: 70
    },
    useSubMenuImage: true
  }
};

//MOBILE HEADER
const mobileHeader = {
  height: {
    xs: 60,
    sm: 60,
    scroll: 60
  },
  search: {
    height: {
      xs: 60,
      sm: 60
    }
  },
  logo: {
    width: '120px'
  },
  background: colors.white,
  color: colors.font,
  nav: {
    lv1: {
      fontSize: remCalc(17),
      fontWeight: typography.header.fontWeight,
      fontFamily: typography.header.fontFamily,
      lineHeight: '3.4em',
      textTransform: 'uppercase'
    },
    lv2: {
      fontSize: '0.9rem',
      lineHeight: '3.2em'
    },
    lv3: {
      fontSize: '0.8rem',
      lineHeight: '3em'
    },
    activeColor: colors.primaryDark,
    selectedColor: colors.primary
  }
};

//HEADER HEIGHTS
const header = {
  height: {
    lg: topBar.height.lg + desktopHeader.height.lg,
    md: topBar.height.md + desktopHeader.height.md,
    sm: topBar.height.md + mobileHeader.height.sm,
    xs: topBar.height.md + mobileHeader.height.xs,
    scroll: topBar.height.scroll + desktopHeader.height.scroll
  },
  scrollBreak: 50
};

//LOGO
const logo = {
  size: 600,
  aspect: '230:40'
};

//CAMPAIGN BAR
const campaignBar = {
  primary: {
    background: colors.backgroundLight,
    color: colors.font
  },
  secondary: {
    background: colors.secondary,
    color: colors.white
  }
};

//FOOTER
const footer = {
  background: colors.white,
  color: colors.font,
  logoBackground: colors.white,
  jetshopBackground: colors.white,
  jetshopColor: colors.font,
  imageAspect: '4:1',
  newsletterButton: {
    background: 'transparent',
    color: colors.black,
    border: '1px solid ' + colors.black
  }
};

//START PAGE
const startPage = {
  headers: {
    fontFamily: typography.header.fontFamily,
    fontWeight: typography.header.fontWeight,
    textTransform: 'none',
    fontSize: [
      '__',
      [remCalc(41), remCalc(62), remCalc(82), remCalc(95)],
      typography.header.fontSize[1],
      typography.header.fontSize[2],
      typography.header.fontSize[3],
      typography.header.fontSize[4]
    ]
  },
  iconBar: {
    background: colors.yellow,
    color: colors.font
  },
  row: {
    background: {
      primary: colors.backgroundLight,
      secondary: colors.backgroundDark
    },
    color: {
      primary: colors.font,
      secondary: colors.font
    },
    noImage: {
      backgroundLight: colors.white,
      backgroundDark: colors.backgroundDark
    }
  },
  readMore: {
    color: colors.primary,
    fontFamily: button.fontFamily,
    fontWeight: button.fontWeight
  },
  cta: {
    fontSize: button.fontSize,
    color: colors.white,
    background: 'transparent',
    border: '4px solid ' + colors.white,
    letterSpacing: button.letterSpacing,
    fontFamily: button.fontFamily,
    fontWeight: button.fontWeight,
    textTransform: 'none',
    borderRadius: '0px',
    hover: {
      color: colors.buy,
      background: 'transparent',
      border: '4px solid ' + colors.white
    },
    secondary: {
      color: colors.white,
      background: colors.font,
      border: '4px solid ' + colors.font,
      hover: {
        color: colors.buy,
        background: colors.font,
        border: '4px solid ' + colors.font
      }
    },
    third: {
      color: colors.white,
      background: colors.primaryDark,
      border: '4px solid ' + colors.primaryDark,
      hover: {
        color: colors.white,
        background: colors.primaryDark,
        border: '4px solid ' + colors.primaryDark
      }
    },
    fourth: {
      color: colors.white,
      background: colors.primaryDark,
      border: '4px solid ' + colors.primaryDark,
      hover: {
        color: colors.white,
        background: colors.primaryDark,
        border: '4px solid ' + colors.primaryDark
      }
    }
  }
};

//CATEGORY PAGE
const categoryPage = {
  subcategories: {
    fontFamily: typography.header.secondFont.fontFamily,
    fontWeight: typography.header.secondFont.fontWeight
  },
  filter: {
    markerColor: colors.buy,
    hoverColor: colors.buy,
    borderColor: colors.borderDark,
    name: {
      tag: 'h4'
    }
  }
};

//PRODUCT GRID
const productGrid = {
  product: {
    imageAspect: '4:3',
    background: '#FFF',
    padding: ['1rem', '1.5rem', '2rem'],
    border: `1px solid #F5F5F5`,
    name: {
      tag: 'h4',
      fontFamily: typography.header.secondFont.fontFamily,
      fontWeight: typography.header.secondFont.fontWeight
    }
  }
};

const price = {
  fontFamily: typography.header.secondFont.fontFamily,
  fontWeight: typography.header.secondFont.fontWeight,
  normal: {
    color: colors.font,
    fontSize: typography.header.fontSize[3]
  },
  new: {
    color: colors.discount,
    fontSize: typography.header.fontSize[3]
  },
  old: {
    color: colors.greys[5],
    fontSize: typography.header.fontSize[4]
  }
};

//PRODUCT PAGE
const productPage = {
  name: {
    fontFamily: productGrid.product.name.fontFamily,
    fontWeight: productGrid.product.name.fontWeight
  },
  price: {
    fontWeight: price.fontWeight,
    normal: {
      fontSize: typography.header.fontSize[2]
    },
    new: {
      fontSize: typography.header.fontSize[2]
    },
    old: {
      fontSize: typography.header.fontSize[3]
    }
  },
  imageAspect: '1:1',
  buyButton: {
    background: colors.font,
    color: colors.white
  },
  usp: {
    fontWeight: weights.light
  },
  tabs: {
    barActiveColor: colors.buy,
    header: {
      tag: 'h3',
      fontFamily: typography.header.secondFont.fontFamily,
      fontWeight: typography.header.secondFont.fontWeight
    }
  },
  productList: {
    headerColor: colors.font,
    subHeaderColor: colors.primary
  }
};

const favourites = {
  colorActive: colors.buy
};

//EXPORT COMPLETE THEME
export const ledlenserTheme = {
  config,
  font,
  weights,
  typography,
  colors,
  general,
  button,
  topBar,
  desktopHeader,
  mobileHeader,
  header,
  logo,
  campaignBar,
  footer,
  startPage,
  categoryPage,
  productGrid,
  price,
  productPage,
  favourites
};
